import { capitalize } from 'lodash';

const determineNameDisplay = (firstName, lastName, shouldCapitalize) => {
    const output = `${firstName || ''}${(firstName && lastName) ? ' ' : ''}${lastName || ''}`.trim();

    if (shouldCapitalize) {
        return output.split(' ').map(capitalize).join(' ');
    }

    return output;
};

export const userInitials = (firstName, lastName) => (capitalize(firstName ? firstName.charAt(0) : '') + capitalize(lastName ? lastName.charAt(0) : ''));

export default determineNameDisplay;
